module.exports = __webpack_public_path__ + "img/grey.76e35b26.png";